import React from 'react';
import ContentController from './ContentController';
import ReactDOM from 'react-dom/client'
import "./assets/css/main.css";
import "./assets/css/bootstrap.scss";

// import the library
import { library } from '@fortawesome/fontawesome-svg-core'

// import your icons
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add(fab, fas, far)

// Get the root element from index.html
const container = document.getElementById('root');

// Create a root and render the app
const root = ReactDOM.createRoot(container); 
root.render(
  <React.StrictMode>
    <ContentController />
  </React.StrictMode>
);